export default __webpack_public_path__ + "static/media/Main-logo.e4e70412.png";